module.exports = __webpack_public_path__ + "static/poster-DEI-pressionaumariage-apercu-2-1200-2e1605e1fa61f9bbf49a7eb9e930ea69.png";